/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".airport-icons[_ngcontent-%COMP%]{display:flex;flex-wrap:wrap}"];
export { styles as styles };
